import { createSlice } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { businessThunks } from './businessThunks';
import type { BusinessState } from './businessTypes';

const initialState: BusinessState = { items: [], byId: {}, currentItem: null, status: 'idle', error: null, totalCount: 0 };

export const businessSlice = createSlice({
  name: 'businesses',
  initialState,
  reducers: {
    clearCurrentBusiness(state) { state.currentItem = null; },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, businessThunks, (b) => b.businessId);
  },
});

export const { clearCurrentBusiness } = businessSlice.actions;
export const businessReducer = businessSlice.reducer;
